import { render } from "./AcademicCalendarPage.vue?vue&type=template&id=1ff0662a&scoped=true"
import script from "./AcademicCalendarPage.vue?vue&type=script&lang=js"
export * from "./AcademicCalendarPage.vue?vue&type=script&lang=js"

import "./AcademicCalendarPage.vue?vue&type=style&index=0&id=1ff0662a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff0662a"]])

export default __exports__